// extracted by mini-css-extract-plugin
export default {"loading_spinner":"Spinner_loading_spinner__8KsDc","spinner":"Spinner_spinner__olKO6","spinner_container":"Spinner_spinner_container__6Ap1D","overlay":"Spinner_overlay__qb1uy"};